
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Bestemployyestransportationcompnies() {



    const cardData =
    {
        keyword: 'Best Employee Transportation Companies in Pune',
        heading: 'etravo : Best Employee Transportation Companies in Pune',
        headingDescription: 'eTravo is recognized among the Best Employee Transportation Companies in Pune, offering dependable and scalable mobility solutions for organizations across industries. Our employee transport services are tailored for IT parks, BPOs, manufacturing units, and corporate offices, ensuring safe, timely, and hassle-free commutes. We operate a fleet of AC cabs, tempo travellers, and buses—each GPS-enabled and managed by professional chauffeurs. With features like route optimization, real-time tracking, and dedicated support, eTravo ensures a seamless experience for both employers and employees. Trust us for efficient, compliant, and cost-effective staff transport across Pune.',

        top: 'Top Places to Visit in Pune with etravo',
         "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Built in 1732 as the seat of the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fortification in Pune. Though much of it was destroyed in an 1828 fire, the surviving structures and gardens offer a glimpse into its grand past. The site is renowned for its architectural features and is a popular tourist attraction."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Constructed in 1892 by Sultan Muhammed Shah Aga Khan III, this palace played a significant role during India's freedom movement. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi during the Quit India Movement. The palace now houses a museum and memorials dedicated to Gandhi and his associates."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located approximately 28 km southwest of Pune, Sinhagad Fort is a hill fortress known for the Battle of Sinhagad in 1670. The fort offers panoramic views and is a popular destination for trekking enthusiasts. It houses memorials and remnants of historical significance."
    },
    {
      "title": "Dagdusheth Halwai Ganapati Temple",
      "description": "This renowned temple is dedicated to Lord Ganesha and is famous for its rich history and the grand idol adorned with gold. It attracts thousands of devotees, especially during the Ganesh Chaturthi festival."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, the Pataleshwar Cave Temple is carved from a single basalt rock. The temple complex includes a circular Nandi mandapa and is a protected monument under the Archaeological Survey of India."
    },
    {
      "title": "Osho International Meditation Resort",
      "description": "Situated in Koregaon Park, this meditation center offers a tranquil environment for spiritual growth and wellness. It attracts visitors worldwide seeking meditation and personal development programs."
    },
    {
      "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
      "description": "Inspired by the 300-year-old Okayama Korakuen Garden in Japan, this beautifully landscaped garden symbolizes the Indo-Japanese friendship. It features manicured lawns, waterfalls, and a serene environment."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses an extensive collection of artifacts showcasing India's rich cultural heritage. Exhibits include musical instruments, sculptures, and everyday objects from the 18th and 19th centuries."
    },
    {
      "title": "Koregaon Park",
      "description": "A vibrant neighborhood known for its lush greenery, upscale eateries, and cultural hubs. Koregaon Park is a popular destination for dining, shopping, and experiencing Pune's cosmopolitan lifestyle."
    },
    {
      "title": "Lal Mahal",
      "description": "Originally built in the 17th century, Lal Mahal is historically significant as the childhood residence of Chhatrapati Shivaji Maharaj. The reconstructed palace now serves as a museum showcasing Maratha history."
    }
  ],



"services": [
  {
    "name": "Best Employee Transportation Companies in Pune",
    "description": "eTravo is among the best employee transportation companies in Pune, offering professional, scalable, and tech-enabled transport services for corporates across all industries and business zones."
  },
  {
    "name": "Reliable Staff Transport Pune",
    "description": "Ensure on-time and stress-free commutes with eTravo’s reliable staff transport in Pune. We provide daily pickup and drop for employees with a well-managed fleet of AC buses and cabs."
  },
  {
    "name": "Affordable Corporate Mobility Pune",
    "description": "eTravo delivers affordable corporate mobility solutions in Pune. Ideal for startups and growing enterprises, our flexible pricing and travel options keep employee transport cost-effective."
  },
  {
    "name": "Top Corporate Commute Providers Pune",
    "description": "Ranked among the top corporate commute providers in Pune, eTravo ensures timely, secure, and efficient travel for your workforce with GPS-enabled vehicles and verified drivers."
  },
  {
    "name": "Staff Bus and Cab Services Pune",
    "description": "eTravo offers staff bus and cab services in Pune with optimized routes and comfortable vehicles. Ideal for companies needing structured pickup and drop schedules for their workforce."
  },
  {
    "name": "Executive Employee Travel Pune",
    "description": "Our executive employee travel services in Pune are tailored for senior staff and top management. eTravo provides luxury cabs and executive buses with professional chauffeurs and priority service."
  },
  {
    "name": "Monthly Corporate Transport Pune",
    "description": "eTravo’s monthly corporate transport plans in Pune offer fixed-cost solutions for businesses that need consistent and dependable employee and executive mobility throughout the month."
  },
  {
    "name": "End-to-End Staff Commute Solutions Pune",
    "description": "eTravo provides end-to-end staff commute solutions in Pune, covering everything from fleet scheduling and route optimization to daily monitoring and support for HR and admin teams."
  },
  {
    "name": "Customized Corporate Transport Pune",
    "description": "Get fully customized corporate transport in Pune with eTravo. We tailor routes, schedules, and vehicle types to suit your unique workforce requirements and operational timings."
  },
  {
    "name": "AC Bus and Cab Hire Pune",
    "description": "eTravo offers AC bus and cab hire in Pune for staff and executive travel. Our clean, air-conditioned vehicles guarantee comfortable transportation for both daily commutes and special events."
  },
  {
    "name": "Staff Movement Companies Pune",
    "description": "eTravo stands out among staff movement companies in Pune, offering flexible transport plans and 24/7 support for industrial zones, tech parks, and commercial districts."
  },
  {
    "name": "Business Travel Solutions Pune",
    "description": "From daily commutes to event transportation, eTravo delivers business travel solutions in Pune that are efficient, cost-effective, and professional—designed for modern corporate needs."
  },
  {
    "name": "Shuttle Services for Employees Pune",
    "description": "eTravo’s shuttle services for employees in Pune are built for punctuality and comfort. We serve major corporate hubs with fixed-route AC buses cab options."
  },
  {
    "name": "Trusted Staff Pickup & Drop Pune",
    "description": "Choose eTravo for trusted staff pickup and drop in Pune. Our transport network is backed by verified drivers, automated attendance tracking, and route customization."
  },
  {
    "name": "Corporate Staff Car and Bus Rentals Pune",
    "description": "eTravo provides corporate staff car and bus rentals in Pune with flexible plans—daily, weekly, or monthly—designed for complete corporate mobility management."
  }
],
"tableData": [
  ["Best Employee Transportation Companies in Pune", "Reliable Staff Transport Pune"],
  ["Affordable Corporate Mobility Pune", "Top Corporate Commute Providers Pune"],
  ["Staff Bus and Cab Services Pune", "Executive Employee Travel Pune"],
  ["Monthly Corporate Transport Pune", "End-to-End Staff Commute Solutions Pune"],
  ["Customized Corporate Transport Pune", "AC Bus and Cab Hire Pune"],
  ["Staff Movement Companies Pune", "Business Travel Solutions Pune"],
  ["Shuttle Services for Employees Pune", "Trusted Staff Pickup & Drop Pune"],
  ["Corporate Staff Car and Bus Rentals Pune", ""]
],




"whychoose": [
    {
        "WhyChooseheading": "Leading Employee Transportation Solutions in Pune",
        "WhyChoosedescription": "eTravo is recognized among the best employee transportation companies in Pune, delivering reliable, safe, and efficient mobility solutions tailored for diverse industries and workforce sizes."
    },
    {
        "WhyChooseheading": "Comprehensive Fleet to Meet Varied Needs",
        "WhyChoosedescription": "Our extensive fleet includes hatchbacks, sedans, SUVs, tempo travellers, and AC buses, ensuring optimal transport options for daily commutes, shift timings, and special events across Pune."
    },
    {
        "WhyChooseheading": "Customized Transport Plans for Pune Businesses",
        "WhyChoosedescription": "We design flexible employee transport packages to suit your company’s size, location, and shift patterns, serving IT parks, manufacturing units, and commercial hubs like Hinjewadi, Magarpatta, and Baner."
    },
    {
        "WhyChooseheading": "Experienced, Verified Drivers with Local Expertise",
        "WhyChoosedescription": "Our drivers are professionally trained, background-verified, and intimately familiar with Pune’s routes—ensuring timely pickups, safe rides, and courteous service."
    },
    {
        "WhyChooseheading": "Transparent Pricing and Easy Billing",
        "WhyChoosedescription": "With upfront pricing, GST-compliant invoicing, and consolidated monthly statements, eTravo makes it easy for your HR and finance teams to manage transportation budgets."
    },
    {
        "WhyChooseheading": "Strict Safety and Hygiene Protocols",
        "WhyChoosedescription": "Regular vehicle sanitation, GPS tracking, seat belts, and onboard safety kits guarantee that employee health and safety remain a top priority in every ride."
    },
    {
        "WhyChooseheading": "Real-Time Ride Monitoring and 24/7 Customer Support",
        "WhyChoosedescription": "Track every trip live and access round-the-clock support for scheduling adjustments, emergencies, or additional transport requirements—ensuring seamless employee mobility."
    },
    {
        "WhyChooseheading": "Scalable Services That Grow with Your Business",
        "WhyChoosedescription": "Whether you’re a startup or a large enterprise, eTravo’s employee transportation services in Pune are designed to scale efficiently as your workforce and operational needs evolve."
    }
]


















    }

const faqData = [
    [
        {
            question: 'Why is eTravo considered one of the best employee transportation companies in Pune?',
            answer: 'eTravo is known for its punctual service, modern fleet, real-time tracking, and strong operational support — making it a preferred choice for employee transportation among top companies in Pune.',
        },
        {
            question: 'What sets eTravo apart from other transport providers in Pune?',
            answer: 'eTravo combines tech-driven solutions like GPS tracking, digital logs, and route optimization with human support through dedicated account managers and responsive ground teams.',
        },
        {
            question: 'Do top IT and industrial firms in Pune use eTravo’s services?',
            answer: 'Yes, leading companies across IT parks and industrial hubs in Pune trust eTravo for safe, reliable, and scalable employee commute solutions.',
        },
        {
            question: 'Is eTravo equipped to handle large-scale employee transport operations?',
            answer: 'Absolutely. With a wide fleet ranging from hatchbacks to 50-seater AC buses, eTravo manages transport for organizations with hundreds of employees and multi-shift schedules.',
        },
        {
            question: 'How does eTravo ensure safety and compliance in Pune?',
            answer: 'eTravo ensures all drivers are verified, vehicles are GPS-enabled, and compliance reports are regularly with clients to maintain transparency and accountability.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Kunal Deshpande',
        designation: 'Operations Manager, AlphaSys Technologies, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“Among all the transport vendors we’ve used, eTravo stands out for their reliability and attention to detail. Their support has been critical to our smooth operations.”',
    },
    {
        name: 'Ms. Pooja Menon',
        designation: 'HR Head, StructSoft Pvt. Ltd., Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has consistently delivered safe and timely transportation for our employees in Pune. Their fleet is clean, their team is responsive, and their tech platform is user-friendly.”',
    },
];

















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Employee Transportation Companies in Pune",
  "image": "https://www.etravo.in/images/keyword/best-employee-transportation-pune.jpg",
  "description": "Top-rated employee transportation services in Pune by eTravo. Offering reliable staff transport, AC bus and cab hire, customized corporate mobility solutions, and monthly corporate commute plans.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6009"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/best-employee-transportation-companies-in-pune"
  }
};






    return (
        <div>

<Helmet>
  <title>Best Employee Transportation Companies in Pune | Staff Transport & Corporate Commute | eTravo</title>
  <meta 
    name="description" 
    content="eTravo ranks among the best employee transportation companies in Pune. Staff transport, shuttle services, AC cab and bus hire, and customized corporate mobility solutions." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/4.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bestemployyestransportationcompnies;